<template>
  <div>
    <head-top></head-top>
    <el-row style="margin-top: 20px;" v-loading="loading">
      <el-col :span="20">
        <el-form ref="formData" label-width="120px" class="demo-formData">
          <el-form-item label="角色名称" prop="name" >
            <el-input v-model="name" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="可操作权限" prop="name" >
            <el-tree :data="menuData" size="mini" show-checkbox node-key="id" :props="defaultProps":check-strictly="true"@check-change="handleMenuCheckChange"
               style="width: 100%;pading-top:20px;" ref="menuTree" :render-content="renderContent">
            </el-tree>
            <div style="float:left;padding-left:24px;padding-top:12px;padding-bottom:4px;">
              <el-checkbox v-model="checkAll" @change="handleCheckAll"><b>全选</b></el-checkbox>
            </div>
          </el-form-item>

          <div class="but_bot">
            <el-button type="primary" @click="submit()">提交</el-button>
            <el-button type="primary" @click="cancel()">取消</el-button>
          </div>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import headTop from '@/components/headTop'
  import { getroleDetail,getModrole } from "../api/api"
  import axios from 'axios'
  export default {
    inject: ['reload'],
    data(){
      return {
        menuData: [],
        defaultProps: {
          children: 'list',
          label: 'name'
        },
        name: '',
        checkAll:false,
        loading:false,
        id:[],
      }
    },
    components: {
      headTop
    },
    methods:{
      //角色详情
      getMenuData(){
        let params = {
          id:this.$route.query.id
        }
        getroleDetail(params).then((res)=>{
          this.menuData = res.menuList
          this.name = res.name
          res.menuList.forEach(element => {
            if (element.have == 1){
              this.id.push(element.id)
              this.$refs.menuTree.setCheckedKeys(this.id,false)
            }
          });
          res.menuList.forEach(element => {
            element.list.forEach(elements => {
              elements.name=elements.name.replace("2","");
              if (elements.have == 1){
                this.id.push(elements.id)
                this.$refs.menuTree.setCheckedKeys(this.id,false)
              }
            });
          });
        }).catch(error=>{
        })
      },
      renderContent(h, { node, data, store }) {
        return (
          <div class="column-container">
          <span style="text-algin:center;margin-right:80px;">{data.name}</span>

          </div>);
      },
      // 树节点选择监听
      handleMenuCheckChange(data, check, subCheck) {
        if(check) {
          // 节点选中时同步选中父节点
          let parentId = data.parentId
          this.$refs.menuTree.setChecked(parentId, true, false)
        } else {
          // 节点取消选中时同步取消选中子节点
          if(data.list != null) {
            data.list.forEach(element => {
              this.$refs.menuTree.setChecked(element.id, false, false)
            });
          }
        }
      },
      // 全选操作
      handleCheckAll() {
        if(this.checkAll) {
          let allMenus = []
          this.checkAllMenu(this.menuData, allMenus)
          this.$refs.menuTree.setCheckedNodes(allMenus)
        } else {
          this.$refs.menuTree.setCheckedNodes([])
        }
      },
      // 递归全选
      checkAllMenu(menuData, allMenus) {
        menuData.forEach(menu => {
          allMenus.push(menu)
          if(menu.list) {
            this.checkAllMenu(menu.list, allMenus)
          }
        });
      },
      //  提交
      submit(){
        if('超级管理员' == this.name) {
          this.$message({message: '超级管理员拥有所有菜单权限，不允许修改！', type: 'error'})
          return
        }else if (this.name == ''){
          this.$message({message: '请输入角色名称！', type: 'error'})
          return
        }
        let checkedNodes = this.$refs.menuTree.getCheckedNodes(false, true)
        let roleMenus = []
        for(let i=0, len=checkedNodes.length; i<len; i++) {
          let roleMenu = {id:checkedNodes[i].roleMenuId, roleId:checkedNodes[i].roleId, menuId:checkedNodes[i].id, operationId: JSON.parse(sessionStorage.getItem('user')).id}
          roleMenus.push(roleMenu)
        }
        if(roleMenus.length == 0) {
          this.$message({message: '至少添加一个权限，不允许为空！', type: 'error'})
          return
        }
        let params = {
          id:this.$route.query.id,
          name:this.name,
          operationId:JSON.parse(sessionStorage.getItem('user')).id,
          roleMenus:JSON.stringify(roleMenus),
        }
        getModrole(params).then((res)=>{
          if (res.state == true) {
            this.$message({
              type: 'success',
              message: res.msg
            });
            this.loading = false
            this.$router.push('privilege')
          }else{
            this.$message({
              type: 'error',
              message: '请上传完整信息'
            });
            this.loading = false
          }
        }).catch(error=>{
          this.loading = false
          console.log(error)
        })
      },
      //取消
      cancel(){
        this.reload()
        this.$router.push('privilege')
      },
    },
    computed: {
    },
    activated () {
      this.getMenuData()
    },
  }
</script>
<style>
  .edit_container{
    padding: 40px;
    margin-bottom: 40px;
  }
  .editer{
    height: 300px;
  }
  .mar{
    margin-top:20px;
  }
  .upload-demo{
    width: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/page/modprivilege.vue